// extracted by mini-css-extract-plugin
export default {"container":"IwHakYJFinpHBfd3PII5","expanded":"dyJfbV7MQuZd0HeJ7Rwv"};